<template>
  <Dialog v-model:visible="showModal" class="w-3/5 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="!showPayStatus"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full text-gray-900 font-semibold">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_title_text']}} - V5</div>
    </template>
    <div class="text-gray-700 text-center font-mono flex flex-wrap py-12 my-2" :class="[bannerColor == 'fb' ? 'bg-plan-A' : 'bg-tiktok-plan-A']">
      <div class="text-white mt-6 pl-12">
        <p class="text-3xl">{{planCheckData.title}}</p>
      </div>
    </div>
    <div class="flex flex-wrap justify-between py-8">
      <ul class="flex-1 space-y-2 mx-8 pl-6 text-gray-500 dark:text-gray-400">
        <li v-for="(item, index) in planCheckData.description">
          <i class="pi pi-check pr-2 text-green-400"></i>
          <span v-html="item"></span>
        </li>
        <li><span class="cursor-pointer text-blue-500 underline" @click="showDisclaimer">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_service_text']}}</span></li>
      </ul>
      <ul class="flex-1 space-y-4 mx-8 pl-6 text-gray-700 dark:text-gray-400">
        <li class="text-2xl font-semibold">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_payment_text']}}</li>
        <li>
          <p class="text-gray-500 font-medium">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_date_text']}}：{{planCheckData.expire_time}}</p>
          <p class="text-gray-500 font-normal">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_price_text']}} {{planCheckData.label_currency}} {{planCheckData.label_PeriodAmount}}</p>
          <p class="text-gray-500 font-normal">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_describe_area_3']}}</p>
        </li>
        <li v-if="planCheckData.haveBind">
          <p class="font-medium">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_bind_card_credit_text']}}</p>
          <p class="text-gray-500 font-normal flex flex-wrap justify-between">
            <span>{{planCheckData.card_no}}</span>
            <a href="javascript:void(0);" class="text-blue-500 underline" @click="payPlan()">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_credit_change_button_text']}}</a>
          </p>
        </li>
        <li v-if="false">
          <p class="font-medium">發票統一編號</p>
          <p class="text-gray-500 font-normal">245646377553</p>
        </li>
      </ul>
    </div>
    <template #footer>
      <div class="w-full text-right py-4 border-t border-gray-400">
        <button
          v-if="(planCheckData.use_plan_id == planCheckData.check_plan_id && planCheckData.is_expired == false) || (planCheckData.use_plan_id > planCheckData.check_plan_id) || planCheckData.PeriodAmount == -1 || planCheckData.PeriodAmount == 0"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showModal=false">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_close_button_text']}}</button>
        <button
          v-else
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showModal=false">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_cancel_button_text']}}</button>
        <button
          v-if="planCheckData.use_plan_id < planCheckData.check_plan_id && planCheckData.PeriodAmount != -1 && planCheckData.PeriodAmount != 0"
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          @click="toPay()">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_pay_button_text']}}
        </button>
        <button
          v-if="planCheckData.use_plan_id == planCheckData.check_plan_id && planCheckData.is_expired == true  && planCheckData.PeriodAmount != -1 && planCheckData.PeriodAmount != 0"
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out mt-32 border-2 border-yellow-400"
          @click="toPayAgain()">{{lang['components']['Dialog']['ChangePlanDialog']['change_plan_card_payagain_button_text']}}
        </button>
      </div>
    </template>
  </Dialog>

  <DisclaimerDialog :list="details" v-bind:lang="lang" v-model:show="showDetail" />

  <form id="plan_form" target="plan_form_open" method="post" action="https://test.autoturn.net/inside/udnapi/account_info/create_hidden_data_v3.php">
      <input type="hidden" id="member_id" name="member_id" :value="planCheckData.memberId">
      <input type="hidden" id="currency" name="currency" :value="planCheckData.currency">
      <input type="hidden" id="price" name="price" :value="planCheckData.PeriodAmount">
      <input type="hidden" id="plan_title" name="plan_title" :value="planCheckData.title">
      <input type="hidden" id="plan_id" name="plan_id" :value="planCheckData.planId">
      <input type="hidden" id="hash" name="hash" :value="this.$route.params.id">
  </form>
  <form id="plan_card_form" method="post" :action="formActive" target="plan_card_form_open">
    <input type="hidden" name="CardID" :value="CardID">
    <input type="hidden" name="ClientRedirectURL" :value="ClientRedirectURL">
    <input type="hidden" name="MerchantID" :value="MerchantID">
    <input type="hidden" name="MerchantMemberID" :value="MerchantMemberID">
    <input type="hidden" name="MerchantTradeDate" :value="MerchantTradeDate">
    <input type="hidden" name="MerchantTradeNo" :value="MerchantTradeNo">
    <input type="hidden" name="ServerReplyURL" :value="ServerReplyURL">
    <input type="hidden" name="stage" :value="stage">
    <input type="hidden" name="TotalAmount" :value="TotalAmount">
    <input type="hidden" name="TradeDesc" :value="TradeDesc">
    <input type="hidden" name="CheckMacValue" :value="CheckMacValue">
  </form>
</template>

<script>
  import Dialog from 'primevue/dialog';
  import DisclaimerDialog from "./DisclaimerDialog.vue";
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'ChangePlanDialog',
    components: {
      Dialog,
      DisclaimerDialog,
      Swal,
      Loading
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      planCheck:{
        type:Object,
      },
      bannerColor: {
        type: String
      },
      memberId: {
        type: Number,
      },
      lang: {
        type: Object
      },
      borderStyle:{
        type: Number
      }
    },
    data() {
      return {
        showPayStatus: true,
        showDetail: false,
        formActive: null,
        CardID: null,
        ClientRedirectURL: null,
        MerchantID: null,
        MerchantMemberID: null,
        MerchantTradeDate: null,
        MerchantTradeNo: null,
        ServerReplyURL: null,
        stage: null,
        TotalAmount: null,
        TradeDesc: null,
        CheckMacValue: null,
      }
    },
    methods: {
      payPlan(){
        axios
          .post('https://test.autoturn.net/inside/api/pay_card_update.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((cuResponse) => {
            // console.log(cuResponse.data);
            if(cuResponse.data.status == 'success'){
              // this.$swal(response.data.info);
              // this.showModal = false;
              // this.isEdit = false;
              this.formActive = cuResponse.data.form_active;
              this.CardID = cuResponse.data.return_data.CardID;
              this.ClientRedirectURL = cuResponse.data.return_data.ClientRedirectURL;
              this.MerchantID = cuResponse.data.return_data.MerchantID;
              this.MerchantMemberID = cuResponse.data.return_data.MerchantMemberID;
              this.MerchantTradeDate = cuResponse.data.return_data.MerchantTradeDate;
              this.MerchantTradeNo = cuResponse.data.return_data.MerchantTradeNo;
              this.ServerReplyURL = cuResponse.data.return_data.ServerReplyURL;
              this.stage = cuResponse.data.return_data.stage;
              this.TotalAmount = cuResponse.data.return_data.TotalAmount;
              this.TradeDesc = cuResponse.data.return_data.TradeDesc;
              this.CheckMacValue = cuResponse.data.return_data.CheckMacValue;

              let TotalAmount_text = this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['total_amount_default_text_a']+'<span style="color:red; font-weight:bold;">'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['total_amount_default_text_b']+cuResponse.data.return_data.TotalAmount+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['total_amount_default_text_c']+'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['total_amount_default_text_d'];

              if(cuResponse.data.return_data.TotalAmount > 5){
                  TotalAmount_text = '<span style="color:red; font-weight:bold;">'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['total_amount_pay_again_text_a']+'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['total_amount_pay_again_text_b'];
              }

              Swal.fire({
                title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['swal_title'],
                html: TotalAmount_text,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['yes_button'],
                cancelButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['pay_plan']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  // 開啟綠界刷卡小視窗
                  var iHeight = 700;
                  var iWidth = 1200;
                  //获得窗口的垂直位置
                  var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                  //获得窗口的水平位置
                  var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                  var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,titlebar=no';

                  var newWindow = window.open('', 'plan_card_form_open',windowStyle);
                  document.getElementById('plan_card_form').submit();

                  let hash = this.$route.params.id;
                  let type = this.$route.params.type;

                  var timer = setInterval(function() {
                    console.log('newWindow:', newWindow);
                      // console.log(timer);
                      if(newWindow.closed) {
                        console.log('已關閉');
                          clearInterval(timer);
                          window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                      }
                  }, 1000);
                }
              })
            }
          });
      },
      toPay(){
        console.log('this.planCheckData.memberId');
        console.log(this.planCheckData.memberId);
        // console.log('this.planCheckData.title');
        // console.log(this.planCheckData.title);
        // console.log('this.planCheckData.currency');
        // console.log(this.planCheckData.currency);
        // console.log('this.planCheckData.PeriodAmount');
        // console.log(this.planCheckData.PeriodAmount);
        // console.log('this.planCheckData.planId');
        // console.log(this.planCheckData.planId);
        console.log('this.planCheckData.payStatus');
        console.log(this.planCheckData.payStatus);

        if(this.planCheckData.payStatus == 'free' || this.planCheckData.haveBind == false){
          // let _tmp_type = this.borderStyle;
          // let type = 'fb';
          // let partner = 'tiktok';

          // console.log('_tmp_type');
          // console.log(_tmp_type);

          // if(_tmp_type == 1){
          //   type = 'tiktok';
          //   partner = 'fb';
          // }

          // axios
          //   .post('https://test.autoturn.net/inside/api/pay_account_span.php', Qs.stringify({
          //     s_code: this.$route.params.id,
          //     member_id: this.planCheckData.memberId,
          //     type: type,
          //   }))
          //   .then((response) => {
          //     console.log('response');
          //     console.log(response);
          //     if(response.data.process_code == 1){
          //       Swal.fire({
          //         icon: response.data.status,
          //         title: '購買方案',
          //         text: response.data.info,
          //         showDenyButton: false,
          //         showCancelButton: false,
          //         confirmButtonText: '好的',
          //         // denyButtonText: `Don't save`,
          //       }).then((result) => {
          //         if (result.isConfirmed) {
          //           console.log('isConfirmed');
          //         } else if (result.isDenied) {
          //           console.log('isDenied');
          //         }
          //       })
          //     } else if(response.data.process_code == 2){
          //       Swal.fire({
          //         icon: response.data.status,
          //         title: '購買方案',
          //         text: response.data.info,
          //         showDenyButton: true,
          //         showCancelButton: false,
          //         confirmButtonText: '好的，我要用'+partner+'所綁定的信用卡付款。',
          //         denyButtonText: '不，我要用另一張卡綁定'+type+'帳號。',
          //       }).then((result) => {
          //         console.log(result);
          //         if (result.isConfirmed) {
          //           console.log('isConfirmed');
          //         } else if (result.isDenied) {
          //           console.log('isDenied');
                    this.showPayStatus = false

                    var iHeight = 700;
                    var iWidth = 1200;
                    //获得窗口的垂直位置
                    var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                    //获得窗口的水平位置
                    var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                    var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,titlebar=no';

                    // console.log('InitiateCheckout'+price);

                    // fbq('track', 'InitiateCheckout', {
                    //     value: price,
                    //     currency: 'USD',
                    // });

                    // window.open('', 'plan_form_open',windowStyle);
                    // document.getElementById('plan_form').submit();

                    var newWindow = window.open('', 'plan_form_open',windowStyle);
                    document.getElementById('plan_form').submit();

                    let hash = this.$route.params.id;
                    let type = this.$route.params.type;

                    var timer = setInterval(function() {
                      console.log('newWindow:', newWindow);
                      // console.log(timer);
                      if(newWindow.closed) {
                        console.log('已關閉');
                        clearInterval(timer);
                        window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                      }
                    }, 1000);
            //       }
            //     })
            //   } else {
            //     Swal.fire(
            //               '購買方案',
            //               response.data.info,
            //               response.data.status
            //             )
            //   }
            // });
        } else {
          let hash = this.$route.params.id;
          let type = this.$route.params.type;

          axios
            .post('https://test.autoturn.net/inside/api/payment_difference.php', Qs.stringify({
              s_code: this.$route.params.id,
              member_id: this.planCheckData.memberId,
              currency: this.planCheckData.currency,
              price: this.planCheckData.PeriodAmount,
              plan_title: this.planCheckData.title,
              plan_id: this.planCheckData.planId,
            }))
            .then((response) => {
              // if(response.data.status == 'success'){
                // this.$swal(response.data.info);
                // this.showModal = false;
                // this.isEdit = false;
              // }
              let update_price = response.data.amount
              Swal.fire({
                title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_title'],
                html: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_html_a']+'<span style="color:red; font-weight:bold;">'+this.planCheckData.title+'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_html_b']+'<span style="color:red; font-weight:bold;">'+this.planCheckData.currency+' $'+ update_price +'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['swal_html_c'],
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['yes_button'],
                cancelButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['payment_difference']['no_button'],
              }).then((result) => {
                if (result.isConfirmed) {
                  // console.log(this.$route.params.id);
                  this.showPayStatus = false

                  axios
                    .post('https://test.autoturn.net/inside/api/plan_update.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      member_id: this.planCheckData.memberId,
                      currency: this.planCheckData.currency,
                      price: update_price,
                      plan_title: this.planCheckData.title,
                      plan_id: this.planCheckData.planId,
                    }))
                    .then((puResponse) => {
                      // if(puResponse.data.status == 'success'){
                        this.showPayStatus = true

                        Swal.fire({
                          icon: puResponse.data.status,
                          title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['plan_update']['swal_title'],
                          text: puResponse.data.info,
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay']['plan_update']['confirm_button'],
                          // denyButtonText: `Don't save`,
                        }).then((result) => {
                          /* Read more about isConfirmed, isDenied below */
                          if (result.isConfirmed) {
                            // Swal.fire('Saved!', '', 'success')
                            window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                          } else if (result.isDenied) {
                            // Swal.fire('Changes are not saved', '', 'info')
                            window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                          }
                          if (result.dismiss === Swal.DismissReason.timer) {
                            window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                          }
                        })
                      // }

                    });
                }
              })

            });
        }

        // Swal.fire({
        //   title: "修改綁定信用卡",
        //   html: "您確定要修改綁定信用卡嗎？",
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: '是',
        //   cancelButtonText: '取消',
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     console.log(this.$route.params.id);

        //     // this.showModal=false;
        //   }
        // })
      },
      toPayAgain(){
        // console.log('toPayAgain');
        // console.log(this.planCheckData.memberId);
        let hash = this.$route.params.id;
        let type = this.$route.params.type;

        Swal.fire({
          title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['swal_title'],
          html: '<span style="color:red; font-weight:bold;">'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['swal_html_a']+'</span>'+this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['swal_html_b'],
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['yes_button'],
          cancelButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['no_button'],
        }).then((result) => {
          if (result.isConfirmed) {
            // console.log(this.$route.params.id);
            this.showPayStatus = false

            axios
              .post('https://test.autoturn.net/inside/api/pay_again.php', Qs.stringify({
                s_code: this.$route.params.id,
                member_id: this.planCheckData.memberId
              }))
              .then((puResponse) => {
                // if(puResponse.data.status == 'success'){
                  this.showPayStatus = true

                  Swal.fire({
                    icon: puResponse.data.status,
                    title: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['pay_again']['swal_title'],
                    text: puResponse.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['components']['Dialog']['ChangePlanDialog']['axios']['to_pay_again']['pay_again']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      // Swal.fire('Saved!', '', 'success')
                      window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                    } else if (result.isDenied) {
                      // Swal.fire('Changes are not saved', '', 'info')
                      window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                    }
                    if (result.dismiss === Swal.DismissReason.timer) {
                      window.location.href = "https://dev-private.autoturn.net/"+type+"/"+hash;
                    }
                  })
                // }

              });
          }
        })
      },
      showDisclaimer(){
        this.showDetail = true
      }
    },
    mounted() {
      const script = document.createElement("script");
      script.src = "https://ecpg-stage.ecpay.com.tw/Scripts/sdk-1.0.0.js?t=20210121100116";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        console.log("ECPay SDK 已載入");
        // 這裡可以使用 ECPay SDK 提供的方法，例如：
        // window.ECPay.doSomething();
      };
    },
    computed: {
      showModal: {
        get: function () {
          return this.show
        },
        set: function (value) {
          this.$emit('update:show', value)
        }
      },
      planCheckData: {
        get: function () {
          return this.planCheck
        },
        set: function (value) {
          this.$emit('update:planCheckData', value)
        }
      }
    }
  }
</script>

<style lang="scss" scope>

</style>